import { useSituacaoStore } from "../../stores/situacaoStore"

let oPromessaChunkSituacoes = null

/** Pré-carrega o chunk da página e aquece o cache paginado (página 1). */
export const prefetchSituacoesPagina = () => {
  if (!oPromessaChunkSituacoes) {
    oPromessaChunkSituacoes = import(/* webpackPrefetch: true */ "../../pages/Situacoes/")
  }

  const oEstado = useSituacaoStore.getState()
  if (!oEstado.lPaginadoInvalido && oEstado.oPaginadoPorChave?.["|1"]) {
    return oPromessaChunkSituacoes
  }

  void useSituacaoStore.getState().paginadaObter({ searchParam: "", pageNumber: 1 })
  return oPromessaChunkSituacoes
}
